import React from 'react';
import InterestClusterPlaceholder from '../../widgets/InterestClusterPlaceholder';

const PromotionalInterestEmbed = () => {
  return (
    <div className="rounded-3xl overflow-hidden shadow-2xl border border-edge bg-surface">
      <div className="promo-interest-embed px-4 py-4 sm:px-5">
        <InterestClusterPlaceholder omitHeading showCta={false} />
      </div>
    </div>
  );
};

export default PromotionalInterestEmbed;
